export const formatUserName = (userName: string): string =>
  userName
    .split(' ')
    .map((value) => value.toLowerCase())
    .map((value) => `${value.charAt(0).toUpperCase()}${value.slice(1)}`)
    .join(' ');
